import { render, staticRenderFns } from "./chooseStu.vue?vue&type=template&id=43ced6cc&scoped=true&"
import script from "./chooseStu.vue?vue&type=script&lang=js&"
export * from "./chooseStu.vue?vue&type=script&lang=js&"
import style0 from "./chooseStu.vue?vue&type=style&index=0&id=43ced6cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ced6cc",
  null
  
)

export default component.exports